// Supermove
import {Form} from '@supermove/hooks';

export interface DeleteCallrailIntegrationFormType {
  // Required fields
  callrailIntegrationId: string;
}

const _new = ({
  callrailIntegrationId,
}: {
  callrailIntegrationId: string;
}): DeleteCallrailIntegrationFormType => {
  return {
    callrailIntegrationId,
  };
};

export type FormikDeleteCallrailIntegrationFormType = Form<{
  deleteCallrailIntegrationForm: DeleteCallrailIntegrationFormType;
}>;

const toMutation = (
  deleteCallrailIntegrationForm: DeleteCallrailIntegrationFormType,
): {
  callrailIntegrationId: string;
} => ({
  callrailIntegrationId: deleteCallrailIntegrationForm.callrailIntegrationId,
});

const DeleteCallrailIntegrationForm = {
  toMutation,
  new: _new,
};

export default DeleteCallrailIntegrationForm;
